import {
  Box,
  AccordionItem,
  AccordionButton,
  AccordionIcon,
  AccordionPanel,
  Accordion,
  HStack,
  Image,
} from '@chakra-ui/react';

import { Directory } from '../../../models';
import FolderIcon from '../../../assets/projects/folder.svg';

export const DocumentNavigational = ({
  directory,
  selectedDirectory,
  onSelectDirectory,
}: {
  directory: Directory;
  selectedDirectory?: Directory;
  onSelectDirectory: (directory?: Directory) => void;
}) => {
  return (
    <Accordion allowToggle w="full">
      <AccordionItem
        onClick={e => {
          e.stopPropagation();
          onSelectDirectory(directory);
        }}
        border="none"
      >
        <h2>
          <AccordionButton
            borderRadius="md"
            bg={
              selectedDirectory?.id === directory.id
                ? 'custom_orange.4'
                : undefined
            }
            _hover={{
              bg:
                selectedDirectory?.id === directory.id
                  ? 'custom_orange.4'
                  : 'blackAlpha.50',
            }}
          >
            <HStack as="span" flex="1" textAlign="left">
              <HStack w="6" h="6">
                <Image src={FolderIcon} />
              </HStack>
              <Box>{directory.directoryName}</Box>
            </HStack>
            <AccordionIcon />
          </AccordionButton>
        </h2>
        {directory.subDirectories.length ? (
          <AccordionPanel pb={4}>
            {directory.subDirectories.map(nestedDirectory => (
              <DocumentNavigational
                key={nestedDirectory.id}
                directory={nestedDirectory}
                selectedDirectory={selectedDirectory}
                onSelectDirectory={onSelectDirectory}
              />
            ))}
          </AccordionPanel>
        ) : null}
      </AccordionItem>
    </Accordion>
  );
};
